export default __webpack_public_path__ + "static/media/community.952d45fd.jpeg";